
import { LucideIcon } from "lucide-react";
import AnimatedCard from "../AnimatedCard";

interface StatsCardProps {
  icon: LucideIcon;
  value: number;
  suffix?: string;
  description: string;
  citation?: {
    number: number;
    link: string;
  };
  delay?: number;
}

const StatsCard = ({ icon: Icon, value, suffix, description, citation, delay }: StatsCardProps) => {
  return (
    <AnimatedCard delay={delay}>
      <div className="text-center p-6 backdrop-blur-lg bg-white/5 border border-white/10 rounded-2xl">
        <div className="inline-flex items-center justify-center w-12 h-12 bg-primary/20 rounded-full mb-4">
          <Icon className="h-6 w-6 text-primary" />
        </div>
        <div className="text-4xl font-bold mb-2 flex items-center justify-center">
          <span data-counter data-value={value} className="mr-1">0</span>
          {suffix && <span>{suffix}</span>}
        </div>
        <p className="text-white/70 whitespace-pre-line">
          {description}
          {citation && (
            <a
              href={citation.link}
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary hover:text-primary/80 ml-1 align-super text-xs"
            >
              ({citation.number})
            </a>
          )}
        </p>
      </div>
    </AnimatedCard>
  );
};

export default StatsCard;
